const getCollectionHandle = () => {
  const collection_grid = document.querySelector('[data-collection-grid]');
  return collection_grid?.dataset?.collection || '';
};

export default (product_handle, add_collection_handle = false) => {
  let product_url = `products/${product_handle}`;
  const current_pathname = window.location.pathname;

  // Absolute URLs can be a problem within the theme editor
  // let product_url = product.url.replace('https://www.astrthelabel.com/', '')
  //   .replace('https://astr-the-label.myshopify.com/', '')
  //   .replace('https://staging-astr-the-label.myshopify.com/', '')
  //   .replace('https://dev-astr-the-label.myshopify.com/', '');

  // Prepend collection handle to product URL if we're on a collection page
  if (add_collection_handle) {
    const collection_handle = getCollectionHandle();
    if (collection_handle && current_pathname.includes('/collections/')) {
      product_url = `collections/${collection_handle}/${product_url}`;
    }
  }

  // Extract locale path if present (e.g., /en-CA/, /fr-CA/, /en-FR/)
  const locale_match = current_pathname.match(/^\/([a-z]{2}-[A-Z]{2}|[a-z]{2}-[a-z]{2}|[a-z]{2}-[A-Z]{2}|[a-z]{2}-[a-z]{2})/);
  const locale_path = locale_match ? locale_match[0] : '';
  product_url = `${locale_path}/${product_url}`.replace(/^\/\//, '/');

  /*
  // Inject attribution tracking to the product URL
  if (typeof product.algolia !== 'undefined') {
    product_url += (product_url.indexOf('?') === -1) ? '?' : '&';
    product_url += 'apid=' + product.algolia.objectID;
  }
  */

  return product_url;
};
